import { ArrowUpBoldIcon } from './ArrowUpBoldIcon';

/**
 * author: Austin Andrews
 * id 36199A40-CCCB-44B9-A6B0-73F7315E5716
 * name arrow-up-bold
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-up-bold.svg
 * tags
 * - Arrow 
 */
export const ArrowTopBoldIcon = ArrowUpBoldIcon;
export default ArrowTopBoldIcon